import { useState, useEffect, useRef, Fragment } from "react";
import { Button, Spinner } from "react-bootstrap";
import SideBar from "./sideBar.jsx";
import userImg from "../../assets/images/chat/user3.png";
import brandLogo from "../../assets/images/chat/favicon.png";
import LinkIcon from "../../assets/images/link-icon.svg";
import "./support.css";
import { toast } from "react-toastify";
import { debounce } from "lodash";
import axios from "axios";
import {
  getActiveUsersAllChats,
  getUserNotification,
  modifyActiveRead,
  getUserSearched,
  decrementNotificationAPI,
  clearUserSupportChat,
} from "./Apis.js";
import {
  Breadcrumb,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { socket } from "../../config/socket.js";
import { getDate, getTime } from "../../utils/timeFunction.js";
import { ModelCrossIcon } from "../../utils/SvgIcons.jsx";

const SupportChat = () => {
  // const { setNotificationMenu } = useContext(UserContext);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const [message, setMessage] = useState("");
  const [mediaFile, setMediaFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [activeUser, setActiveUser] = useState(null);
  const [chats, setChats] = useState([]);
  const [users, setUsers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [active, setActive] = useState(0);
  const [openUsers, setOpenUsers] = useState(false);
  const [mediaError, setMediaError] = useState(null);
  const [typing, settyping] = useState(false);
  let mbLimit = 99 * 1024 * 1024;
  let prevDate = null;

  const handleMessage = (e) => {
    setMessage(e.target.value);
    settyping(true);
  };

  const fetchDataFromAPI = async () => {
    const response = await getUserNotification();
    if (response?.code === 200) {
      setUsers(response?.users);
      if (response?.users?.length > 0) {
        handleSelectUser(response.users[0]);
      } else {
        setChats([]);
        setActiveUser(null);
        setActive(0);
      }
    } else {
      setIsLoading(false);
      toast.error(response.message, { toastId: "error-fetching-users" });
    }
  };

  const fetchDataFromAPIViaSocket = async (activeUser) => {
    const response = await getUserNotification(activeUser);
    if (response?.data?.code === 200) {
      setUsers(response?.data?.users);
    }
  };

  const handleSelectUser = async (activeUserDetail, i = 0) => {
    settyping(false);
    setIsLoading(true);
    setSendLoading(false);
    if (activeUser?._id) {
      socket.emit("adminTyping", { userId: activeUser?._id, typing: false });
    }
    const userId = activeUserDetail?.userId[0];
    const response = await getActiveUsersAllChats(userId);
    if (response?.code === 200) {
      setChats(response?.chats);
      setActiveUser(activeUserDetail);
      const response1 = await modifyActiveRead(userId);
      if (response1?.code === 200) {
        setUsers(response1?.users);
        setActive(i);
        setIsLoading(false);
        setOpenUsers(false);
      } else {
        toast.error(response1.message, { toastId: "error-fetching-users" });
        setIsLoading(false);
      }
    } else {
      toast.error(response.message, { toastId: "error-fetching-chats" });
      setIsLoading(false);
    }
  };

  const handleClearChat = async (userDetail) => {
    if (!userDetail?._id) {
      toast.error("User ID is missing. Cannot clear chat.");
      return;
    }
    try {
      const response = await clearUserSupportChat(userDetail._id);
      if (response?.code === 200) {
        await fetchDataFromAPI();
        toast.success("Support chat successfully cleared.", {
          toastId: "SupportChatClear",
        });
      } else {
        toast.error("Failed to clear support chat.");
      }
    } catch (error) {
      console.error("Error clearing support chat:", error);
      toast.error("An error occurred while clearing the chat.");
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView();
  };

  const handleMediaChange = (event) => {
    setMediaFile(event.target.files[0]);
    setMediaError(null);
  };

  const handleRemoveMedia = () => {
    setMediaError(null);
    setMediaFile(null);
    inputRef.current.value = null;
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (!activeUser) {
      return;
    }
    if (mediaFile) {
      if (mediaFile?.size > mbLimit) {
        setMediaError("Image/Video Size should be less than 100 MB");
        return;
      }

      setSendLoading(true);
      const eventType = "adminReply";
      const messageData = {
        mediaFile: mediaFile,
        isAdmin: true,
        userId: activeUser.userId[0],
        createdAt: new Date(),
        type: "file",
      };

      socket.emit(eventType, messageData);
      setMediaFile(null);
      inputRef.current.value = null; // Reset the input element
    } else if (message) {
      settyping(false);

      setSendLoading(true);
      const eventType = "adminReply";
      const messageData = {
        message: message,
        isAdmin: true,
        userId: activeUser.userId[0],
        createdAt: new Date(),
        type: "text",
      };

      socket.emit(eventType, messageData);
      socket.emit("adminTyping", { userId: activeUser._id, typing: false });
      setMessage("");
    }
  };

  useEffect(() => {
    let timeoutId;
    if (typing) {
      if (activeUser?._id) {
        socket.emit("adminTyping", { userId: activeUser?._id, typing: true });
      }
      timeoutId = setTimeout(() => {
        settyping(false);
        if (activeUser?._id) {
          socket.emit("adminTyping", {
            userId: activeUser?._id,
            typing: false,
          });
        }
      }, 5000);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (activeUser?._id) {
        socket.emit("adminTyping", { userId: activeUser?._id, typing: false });
      }
      socket.off("adminTyping");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, typing]);

  useEffect(() => {
    const decrementNotification = async () => {
      await decrementNotificationAPI({ type: "supportChatNotify" });
      // setNotificationMenu((prev) => ({ ...prev, supportChatNotify: 0 }));
    };
    decrementNotification();
    fetchDataFromAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    socket.on("newUserMessage", (message) => {
      if (message.userId.toString() === activeUser?.userId?.[0].toString()) {
        setChats((prev) => [...prev, message]);
        fetchDataFromAPIViaSocket(activeUser.userId?.[0].toString());
      } else {
        fetchDataFromAPIViaSocket();
      }
    });

    socket.on("newAdminMsg", (message) => {
      if (message?.error) {
        toast.error(message?.error, { id: "error-fetching-chats" });
        setSendLoading(false);
      }
      if (message.userId.toString() === activeUser.userId[0].toString()) {
        setChats((prev) => [...prev, message]);
        setSendLoading(false);
      }
    });
    return () => {
      socket.off("newUserMessage");
      socket.off("newAdminMsg");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeUser]);

  useEffect(() => {
    if (!isFirstRender) {
      const source = axios.CancelToken.source();
      const fetchSearchInput = async () => {
        const response = await getUserSearched(searchInput, source.token);
        if (response?.code === 200) {
          setUsers(response?.users);
        } else {
          toast.error(response?.message, { id: "error-fetching-users" });
        }
      };
      const debouncedFetchData = debounce(fetchSearchInput, 600);
      debouncedFetchData();
      return () => {
        source.cancel("Request canceled");
      };
    } else {
      setIsFirstRender(false);
    }
  }, [searchInput, isFirstRender]);

  return (
    <Fragment>
      <Breadcrumb title="Support Chat Management" parent="Support-Chat" />
      <Container fluid={true} className="support-chat">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <h5> Support Chat Management </h5>
              </CardHeader>
              <CardBody>
                <div className="admin-live-chat">
                  <div className="container1">
                    <div className="admin-content-wrapper">
                      {/* Button only for mobile devices */}
                      <Button
                        className="user-btn"
                        onClick={() => setOpenUsers(!openUsers)}
                      >
                        Users
                      </Button>
                      <div
                        className={`admin-support-adminchat-content ${
                          openUsers ? "open-users" : "close-users"
                        }`}
                      >
                        <SideBar
                          users={users}
                          handleSelectUser={handleSelectUser}
                          searchInput={searchInput}
                          setSearchInput={setSearchInput}
                          active={active}
                        />
                        <div
                          className="adminchat"
                          onClick={() => setOpenUsers(false)}
                        >
                          <div className="adminchat-header">
                            {activeUser ? (
                              <div className="adminchat-header-info-suport">
                                <div className="adminchat-header-user">
                                  <img
                                    src={activeUser.avatar || userImg}
                                    alt="avatar"
                                  />
                                  <div className="adminchat-header-user-info">
                                    <h6>{activeUser.userName[0]}</h6>
                                    <p>{activeUser.email[0]}</p>
                                  </div>
                                </div>
                                <div className="adminchat-header-sub-info admin-info">
                                  <button
                                    className="clear-chat-btn"
                                    onClick={() => handleClearChat(activeUser)}
                                  >
                                    Clear Chat
                                  </button>
                                  <div className="adminchat-header-sub-info-box">
                                    <p>Registration</p>
                                    <h6>{getDate(activeUser.createdAt[0])}</h6>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="adminchat-header-user">
                                  <img
                                    style={{ visibility: "hidden" }}
                                    src={""}
                                    alt="avatar"
                                  />
                                  <div className="adminchat-header-user-info">
                                    <h6>{"No Chats"}</h6>
                                    <p>{""}</p>
                                  </div>
                                </div>
                                <div className="adminchat-header-sub-info">
                                  <div className="adminchat-header-sub-info-box">
                                    <p>{""}</p>
                                    <h6>{""}</h6>
                                  </div>
                                  <div className="adminchat-header-sub-info-box">
                                    <p>{""}</p>
                                    <h6>{""}</h6>
                                  </div>
                                  <div className="adminchat-header-sub-info-box">
                                    <p>{""}</p>
                                    <h6 className="bold-text">
                                      {/* <img src={coinicon} alt='coinimage' /> {''} */}
                                    </h6>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          <div className="adminchat-history">
                            <ul
                              id="chatbox"
                              className={
                                isLoading
                                  ? "center_loader"
                                  : mediaFile && "imageUploaded"
                              }
                            >
                              {isLoading && (
                                <Spinner
                                  animation="border"
                                  variant="dark"
                                  size="xxl"
                                />
                              )}
                              {!isLoading &&
                                chats &&
                                chats.length > 0 &&
                                chats.map((specificMessage, index) => {
                                  // Format the current message's date
                                  const currentDate = new Date(
                                    specificMessage.createdAt
                                  );
                                  const formattedDate =
                                    currentDate.toLocaleDateString();

                                  // Check if the current date is different from the previous date
                                  const displayDateSeparator =
                                    formattedDate !== prevDate;

                                  // Update the previous date to the current date
                                  prevDate = formattedDate;

                                  return (
                                    <div key={index}>
                                      {/* If the current date is different from the previous date, display the date separator */}
                                      {displayDateSeparator && (
                                        <li className="date-separator  text-center d-block">
                                          {formattedDate}
                                        </li>
                                      )}
                                      {specificMessage.isAdmin ? (
                                        <>
                                          <AdminMessage
                                            key={specificMessage?._id}
                                            message={
                                              specificMessage?.message ||
                                              specificMessage?.filePath
                                            }
                                            type={
                                              specificMessage?.message
                                                ? "text"
                                                : "image-video"
                                            }
                                            userImg={
                                              activeUser.avatar[0] || userImg
                                            }
                                            createdAt={
                                              specificMessage?.createdAt
                                            }
                                            messagesEndRef={messagesEndRef}
                                            scrollToBottom={scrollToBottom}
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <UserMessage
                                            key={specificMessage?._id}
                                            message={
                                              specificMessage?.message ||
                                              specificMessage?.filePath
                                            }
                                            type={
                                              specificMessage?.message
                                                ? "text"
                                                : "image-video"
                                            }
                                            userImg={
                                              activeUser.avatar || userImg
                                            }
                                            createdAt={
                                              specificMessage?.createdAt
                                            }
                                            messagesEndRef={messagesEndRef}
                                            scrollToBottom={scrollToBottom}
                                          />
                                        </>
                                      )}
                                    </div>
                                  );
                                })}
                            </ul>
                          </div>

                          <div className="adminchat-message clearfix">
                            <form>
                              <div className="send-section">
                                <div className="upload-media-section">
                                  <span className="upload-media-for-support">
                                    <label
                                      htmlFor="media"
                                      style={{ marginBottom: "0px" }}
                                    >
                                      <img src={LinkIcon} alt="" />
                                    </label>
                                    <input
                                      type="file"
                                      id="media"
                                      name="media"
                                      accept="image/*,video/*"
                                      onChange={handleMediaChange}
                                      ref={inputRef}
                                      style={{ display: "none" }}
                                    />
                                  </span>

                                  <div className="support-cross">
                                    {mediaFile &&
                                      mediaFile.type.startsWith("image/") && (
                                        <div className="support-media-cross">
                                          <span
                                            className="cross-button-for-docs bg-primary cursor-pointer"
                                            onClick={handleRemoveMedia}
                                          >
                                            <ModelCrossIcon />
                                          </span>
                                          <img
                                            src={URL.createObjectURL(mediaFile)}
                                            alt="Uploaded media"
                                            className="uploadImg "
                                          />
                                        </div>
                                      )}

                                    {mediaFile &&
                                      mediaFile.type.startsWith("video/") && (
                                        <div className="support-media-cross">
                                          <span
                                            className=" cross-button-for-docs bg-primary cursor-pointer"
                                            onClick={handleRemoveMedia}
                                          >
                                            <ModelCrossIcon />
                                          </span>

                                          <video
                                            src={URL.createObjectURL(mediaFile)}
                                            alt="Uploaded media"
                                            className="upload-media"
                                            controls
                                            // style={{ width: "100%", height: "100%" }}
                                          />
                                        </div>
                                      )}
                                    {mediaError && (
                                      <p className="pt-2 text-danger">
                                        {mediaError}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="message"
                                  id="message-to-send"
                                  value={message}
                                  placeholder="Write message to User"
                                  onChange={handleMessage}
                                />
                                <Button type="submit" onClick={sendMessage}>
                                  {sendLoading ? (
                                    <Spinner
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    "Send"
                                  )}
                                </Button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

const AdminMessage = ({
  message,
  userImg,
  messagesEndRef,
  createdAt,
  scrollToBottom,
  type,
}) => {
  function isImage(url) {
    return /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(url);
  }

  function isVideo(url) {
    return /\.(mp4|webm|ogg)$/i.test(url);
  }

  function renderMedia(url) {
    if (isImage(url)) {
      return <img src={url} alt="AdminMessage" />;
    } else if (isVideo(url)) {
      return <video src={url} controls />;
    } else {
      return <p>This URL does not point to a valid image or video.</p>;
    }
  }

  useEffect(() => {
    scrollToBottom();
  }, [scrollToBottom]);
  const handleCopy = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      toast.success("Text copied to clipboard", { id: "copy-success" });
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <li className="clearfix admin-message-on-support">
      <div className="admin-message" ref={messagesEndRef}>
        <div className="message-section">
          <div className="message-box" onClick={() => handleCopy(message)}>
            {type === "text" && <h6>{message}</h6>}
            {type === "image-video" && renderMedia(message)}
          </div>
          <p>{getTime(createdAt)}</p>
        </div>
        <div className="admin-message-icon">
          <img src={brandLogo} alt="user" />
        </div>
      </div>
    </li>
  );
};

const UserMessage = ({
  message,
  userImg,
  createdAt,
  messagesEndRef,
  scrollToBottom,
  type,
}) => {
  function isImage(url) {
    return /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(url);
  }

  function isVideo(url) {
    return /\.(mp4|webm|ogg)$/i.test(url);
  }

  function renderMedia(url) {
    if (isImage(url)) {
      return <img src={url} alt="User Message" style={{ height: 80 }} />;
    } else if (isVideo(url)) {
      return <video src={url} controls />;
    } else {
      return <p>This URL does not point to a valid image or video.</p>;
    }
  }

  useEffect(() => {
    scrollToBottom();
  }, [scrollToBottom]);

  const handleCopy = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      toast.success("Text copied to clipboard", { id: "copy-success" });
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <li>
      <div className="user-message" ref={messagesEndRef}>
        <div className="user-message-icon">
          <img src={userImg} alt="user" />
        </div>
        <div className="message-section">
          <div className="message-box" onClick={() => handleCopy(message)}>
            {type === "text" && <h6>{message}</h6>}
            {type === "image-video" && renderMedia(message)}
          </div>
          <p>{getTime(createdAt)}</p>
        </div>
      </div>
    </li>
  );
};

export default SupportChat;
